"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultManagementExtendedSchema = void 0;
var default_management_schema_1 = require("./default-management-schema");
exports.defaultManagementExtendedSchema = __assign(__assign({}, default_management_schema_1.defaultManagementSchema), { allOf: [
        {
            if: {
                properties: {
                    toolAppliedFlag: {
                        enum: [true, 'true'],
                    },
                },
            },
            then: {
                required: ['approvedDate', 'toolDescription'],
                properties: {
                    toolDescription: {
                        type: 'string',
                        minLength: 1,
                        maxLength: 1000,
                    },
                },
            },
        },
    ] });
